import React from 'react';

function TwoColumns({
  text,
  image,
  hasContainer,
  bgColor,
  id,
  className,
  reverse = false,
  textClassName,
  containerClassName = '',
  cancelSpace = false,
  imageClassName = '',
}) {
  return (
    <section id={id} className={`${className || ''}`}>
      <div className={`${hasContainer ? 'container' : ''} `}>
        <div
          className={`flex flex-wrap -ml-12 justify-between ${!cancelSpace && 'space-y-12 md:space-y-0'}  ${
            reverse && 'md:flex-row-reverse'
          } ${containerClassName}`}
        >
          <div className={`flex items-center pl-12 w-full md:w-1/2 ${textClassName || 'justify-center'} `}>{text}</div>
          <div className={`flex items-center justify-center w-full pl-12 md:w-1/2 ${imageClassName}`}>{image}</div>
        </div>
      </div>
    </section>
  );
}

export default TwoColumns;

export function TwoThirdsColumns({ left, right, hasContainer, id, className, reverse = false, leftClassName }) {
  return (
    <section id={id} className={`${className || ''}`}>
      <div className={`${hasContainer ? 'container' : ''} `}>
        <div className={`flex flex-col md:flex-row -ml-12 ${reverse && 'md:flex-row-reverse'}`}>
          <div className={`flex pl-12 md:w-1/2 lg:w-1/2 xl:w-1/3 ${leftClassName || 'justify-center items-center'} `}>
            {left}
          </div>
          <div className="flex items-center pl-12 md:justify-end lg:w-1/2 xl:w-2/3 ">{right}</div>
        </div>
      </div>
    </section>
  );
}
